import React from 'react';
import {
    ModalTest,
    ModalBody,
    ModalCard,
    ModalCardContent
} from './StyleComponents/StyleCustomModal';
import CardTitleContainer from '../layout/CardTitleContainer';
import Typography from '@material-ui/core/Typography';
import {
    CloseButton
} from '../../style/Global';

function CustomModal(props) {
    const {
        modalStyle = {}
    } = props;

    // console.log('modal style', modalStyle);
    return (
        <ModalTest
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={true}
            onClose={props.closeModal}
            
        >
            <ModalCard className='ref-modal-card' style={modalStyle}>
                <ModalCardContent>
                    <CardTitleContainer>
                        <Typography
                            variant='h4' 
                            gutterBottom
                            style={{
								color:'#FF6B6B'
							}}
                        >
                            {props.modalTitle}
                        </Typography>
                        <CloseButton
                            onClick={props.closeModal}
                        />
                    </CardTitleContainer>
                    <ModalBody className='ref-modal-body'>
                        {props.modalBody}
                    </ModalBody>
                </ModalCardContent>
            </ModalCard>
        </ModalTest>
    )
}

export default CustomModal;